import React, { createContext, useContext, useState, useEffect } from 'react';
import { supabase } from '../utils/supabaseClient';
import { useAuth } from './AuthContext';

const ResumeContext = createContext();

export const useResume = () => useContext(ResumeContext);

export const ResumeProvider = ({ children }) => {
  const { user } = useAuth();
  const [currentResume, setCurrentResume] = useState(null);
  const [resumes, setResumes] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchResumes = async () => {
    if (!user) return;
    setLoading(true);
    const { data, error } = await supabase
      .from('resumes')
      .select('*')
      .eq('user_id', user.id)
      .order('updated_at', { ascending: false });
    if (!error) setResumes(data || []);
    setLoading(false);
  };

  const fetchResume = async (id) => {
    if (!user) return;
    const { data, error } = await supabase
      .from('resumes')
      .select('*')
      .eq('id', id)
      .single();
    if (!error) {
      setCurrentResume(data);
      return data;
    }
    return null;
  };

  const saveResume = async (resumeData) => {
    if (!user) return null;
    const { data, error } = await supabase
      .from('resumes')
      .upsert({
        ...resumeData,
        user_id: user.id,
        updated_at: new Date()
      })
      .select()
      .single();
    if (!error) {
      await fetchResumes();
      return data;
    }
    return null;
  };

  const deleteResume = async (id) => {
    const { error } = await supabase
      .from('resumes')
      .delete()
      .eq('id', id);
    if (!error) {
      await fetchResumes();
      return true;
    }
    return false;
  };

  useEffect(() => {
    fetchResumes();
  }, [user]);

  const value = {
    currentResume,
    resumes,
    loading,
    fetchResumes,
    fetchResume,
    saveResume,
    deleteResume,
    setCurrentResume
  };

  return (
    <ResumeContext.Provider value={value}>
      {children}
    </ResumeContext.Provider>
  );
};